import { render } from "./EmployeeApprovedRequests.vue?vue&type=template&id=daff50b6"
import script from "./EmployeeApprovedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__